// -----------------------------------------------------------------------------
export enum KnownRawGlobalConfigs {
  AutoDismissNotificationsSecs = 'auto_dismiss_notifications_seconds',
  ResetNotificationCapPeriodWeeks = 'res_notification_cap_period_weeks',
  // eslint-disable-next-line max-len
  CooldownFromPreviousNotificationsHours = 'cooldown_from_previous_notification_hours',
  CooldownFromOverwolfLaunchMinutes = 'cooldown_from_ow_launch_mins',
  CooldownFromOverwolfInstallationHours = 'cooldown_from_ow_installation_hours',
  MinimumVisibleTimeToCountInSeconds = 'min_visible_time_to_count_seconds',
  PassiveAnalyticsPersistentPhasing = 'passive_analytics_persistent_phasing',
  // eslint-disable-next-line max-len
  MinimumGameSessionTimeToDisplayNotificationMins = 'minimum_game_session_time_to_display_notification_mins',
  // eslint-disable-next-line max-len
  ResetNotificationDismissPeriodWeeks = 'res_notification_dismiss_period_weeks',
}

// -----------------------------------------------------------------------------
export interface RawGlobalConfigurations {
  [key: string]: string;
}

export interface RawHostExtensionConfigurations {
  id: number;
  enabled: boolean;
  phasing: number;
}

export interface HostExtensionConfigurations {
  id: string;
  enabled: boolean;
  phasing: number;
}
